module.exports = __webpack_public_path__ + "ead0d1b1023ac3d28c9d2ecfd7419757.svg";